module.exports = __webpack_public_path__ + "static/TechLounge-edd6cebe88f1ab3d7ea262c4677869a4.png";